
import { Vue, Component, Prop } from 'vue-property-decorator'
import DashboardMarket from '../../components/Dashboards/DashboardMarket.vue'
  @Component({
    name: 'student',
    components: { DashboardMarket }
  })
export default class student extends Vue {
  mounted() {}
}
